import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

import LeftArrowIcon from 'assets/icons/left_arrow.svg';
import RightArrowIcon from 'assets/icons/right_arrow.svg';

const ArrowButton = ({ direction, onClick }) => {
  const isLeft = direction === 'left';

  return (
    <img
      className={`arrow arrow-${isLeft ? 'left' : 'right'}`}
      src={isLeft ? LeftArrowIcon : RightArrowIcon}
      alt={`${isLeft ? 'Left' : 'Right'} Arrow`}
      onClick={onClick}
    />
  );
};

ArrowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
};

export default ArrowButton;
